function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M127.6 99.2c-21 0-38.5 15.4-41.9 35.4h-29v-21.3H42.5v21.3h-7.1v-21.3H21.3v21.3h-7.1v-21.3H0V163h85.6c3.4 20.1 20.9 35.4 41.9 35.4h155.9V99.2H127.6zm127.5 70.9H127.6c-7.8 0-14.2-6.4-14.2-14.2v-14.2c0-7.8 6.4-14.2 14.2-14.2h127.6l-.1 42.6zM70.9 85V63.8H21.3C9.5 63.8 0 73.3 0 85v21.3h49.6c11.7 0 21.3-9.5 21.3-21.3zm-56.7 0c0-3.9 3.2-7.1 7.1-7.1h35.4V85c0 3.9-3.2 7.1-7.1 7.1H14.2V85zm124 53.2c5.9 0 10.6 4.8 10.6 10.6s-4.8 10.6-10.6 10.6-10.6-4.8-10.6-10.6 4.7-10.6 10.6-10.6z"
})));